module.exports = __webpack_public_path__ + "img/pm.9c52365a.svg";